package one.healthium.med.providers

import ifaandroid.apps.med.composeapp.generated.resources.Res
import one.primehealth.app.BaseAppResourceProvider

class AppResourceProvider : BaseAppResourceProvider {
    override suspend fun readBytes(path: String): ByteArray {
        return Res.readBytes(path)
    }
}